import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { HdsBadge } from '@hashicorp/design-system-components/components';

export default class CoreBdageNew extends Component {
  <template>
    <HdsBadge @text={{t "components.core.badge.new"}} @color="highlight" />
  </template>
}
